import { Route } from 'vue-router';
import Vue from 'vue';
import _ from '../utils';
import { Guard } from '../plugins/guards/guardWrapper';

export default {
  name: 'ApiKeyGuard',
  registerInterceptor: () => ({
    name: 'ApiKeyInterceptor, uses api-key if configured',
    request(requestType, apiEndpoint, params) {
      if (Vue.$config.values['auth-apikey']) {
        if (Vue.$fetch.defaults.headers['x-api-key'] !== Vue.$config.values['auth-apikey']) {
          Vue.$log.info('🔑 [ApiKeyInterceptor] setting api-key from config');
          Vue.$fetch.defaults.headers['x-api-key'] = Vue.$config.values['auth-apikey'];
        }
      }
    },
  }),
} as Guard;
